@include host-component-properties;

:host {
  --paf-icon-utilization-aspect-ratio: auto;
  --paf-icon-attributes-level-2-height: 16;
  --paf-icon-attributes-level-1-height: 20;
  --paf-icon-attributes-level-1-height-mobile: var(--paf-icon-attributes-level-2-height);
}

.attributes-list {
  @include reset-list;

  display: flex;
  column-gap: px-to-rem(var(--paf-global-spacing-fixed-2x));

  --paf-icon-aspect-ratio: var(--paf-icon-utilization-aspect-ratio);
}

.attributes-list--level-1 {
  --paf-icon-attributes-height: var(--paf-icon-attributes-level-1-height-mobile);

  @include mq($from: small) {
    --paf-icon-attributes-height: var(--paf-icon-attributes-level-1-height);
  }
}

.attributes-list--level-2 {
  --paf-icon-attributes-height: var(--paf-icon-attributes-level-2-height);

  flex-wrap: wrap;
  gap: px-to-rem(var(--paf-global-spacing-fixed-2x));
}

paf-icon {
  @include forced-colors-dark {
    filter: invert(1);
  }
}
